import React from 'react';
import { Button, Typography } from '@material-ui/core';
import { keyEmptyCheck } from '../../utils/utils';
import './styles.css';
import ADGMImage from '../ADGMImage';
export default function ErrorBoundayPage() {
  return (
    <div className='ErrorBoundayContainer'>
      <ADGMImage name='adgm-logo.svg' alt='ADGMLogo' />
      <Typography variant='h4' color='textSecondary'>
        {keyEmptyCheck('oops_something_went_wrong')}
      </Typography>
      <Button variant='contained' color='secondary' component='a' href='/'>
        {keyEmptyCheck('button')}
      </Button>
    </div>
  );
}
